// extracted by mini-css-extract-plugin
module.exports = {"disabled":"SituasjonskortPart_disabled__fiZsX","disabledMsg":"SituasjonskortPart_disabledMsg__URBNf"};